<template>
  <div>
    <div class="ticket-card" :class="{'open':status === 'created','closed':status === 'closed'}">
      <div class="ticket-card-name">
        <router-link :to="'/support/ticket/'+id">
          <span>#Ticket {{id}} from {{ event_time | moment("MM-DD-YYYY") }}</span>
        </router-link>
      </div>
      <div>
        <router-link :to="'/support/ticket/'+id" class="status" :class="{'open':status === 'created','closed':status === 'closed'}">
          <span v-if="status === 'created'">Open ticket</span>
          <span v-if="status === 'closed'">Closed ticket</span>
        </router-link>
      </div>
      <div v-if="count_new_messages" class="ticket-circle-message"><span>{{ count_new_messages }}</span></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TicketCard',
  data() {
    return {}
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: '0'
    },
    status: {
      type: String
    },
    event_time: {
      type: String,
      default: '1970/1/1'
    },
    count_new_messages: {
      type: Number,
      default: 0,
    }
  },
  methods: {}
}
</script>
<style scoped lang="sass">
.ticket-card
  position: relative
  cursor: pointer
  box-shadow: 0 0 20px #00000010
  padding: 10px 20px
  border-radius: 5px
  margin: 0 0 10px 0
  display: flex
  align-items: center
  justify-content: space-between
  border: 1px solid #d7d7d7
  &-name
    font-size: 0.9em
    font-weight: 600
    a
      color: #454545
  .status
    background: #d7d7d7
    font-size: 0.7em
    padding: 2px 10px
    border-radius: 3px
    font-weight: 600
  .status.open
    background: #00BF66
    color: #fff
  .status.closed
    background: #ea7052
    color: #fff
.ticket-card.open
  border-left: 4px solid #00BF66
.ticket-card.closed
  border-left: 4px solid #ea7052

.ticket-card .ticket-circle-message
  position: absolute
  width: 24px
  height: 24px
  display: flex
  justify-content: center
  text-align: center
  align-items: center
  font-size: 12px
  color: #ffffff
  border-radius: 12px
  background-color: #EF5350
  right: -11px
  top: -13px

@media (max-width: 768px)
  .ticket-card .ticket-circle-message
    right: -5px

</style>